@if (data) {
<div class="account-wrapper">

  <!-- HEADER -->
  <div class="header">
    <div class="header-inner">
      <div class="header-left">
        <div class="account-badge">{{ data.product }}</div>
        <div class="company-name">{{ data.name }}</div>
        <div class="account-number">{{ accountNoParts[0] }}<span>/</span>{{ accountNoParts[1] }}</div>
      </div>
      <div class="header-right">
        <div class="meta-row">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
          <span class="as-of">As at {{ data.date }}</span>
        </div>
        <div class="meta-row">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <strong>{{ data.acctOfficer }}</strong>
        </div>
        <div class="meta-row">
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/></svg>
          <span>Customer ID <strong>{{ data.customer }}</strong></span>
        </div>
      </div>
    </div>
  </div>

  <!-- METRICS GRID -->
  <div class="grid">

    <!-- Working Balance -->
    <div class="card primary">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
        Working Balance
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount large green">
        {{ splitAmount(data.workingBal)[0] }}<span class="amount-cents">{{ splitAmount(data.workingBal)[1] }}</span>
      </div>
    </div>

    <!-- Draw Power -->
    <div class="card primary">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        Draw Power
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount large">
        {{ splitAmount(data.drawPower)[0] }}<span class="amount-cents">{{ splitAmount(data.drawPower)[1] }}</span>
      </div>
    </div>

    <!-- Float Amount -->
    <div class="card warning">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        Float Amount
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount" [class.muted]="isMuted(data.floatAmt)">
        {{ splitAmount(data.floatAmt)[0] }}<span class="amount-cents">{{ splitAmount(data.floatAmt)[1] }}</span>
      </div>
      @if (!isMuted(data.floatAmt)) {
        <div class="badge badge-amber">
          <span class="badge-dot"></span> Pending Authorisation
        </div>
      }
    </div>

    <!-- Lock Amount -->
    <div class="card">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        Lock Amount
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount" [class.muted]="isMuted(data.lockAmt)">
        {{ splitAmount(data.lockAmt)[0] }}<span class="amount-cents">{{ splitAmount(data.lockAmt)[1] }}</span>
      </div>
    </div>

    <!-- Limit Available -->
    <div class="card">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
        Limit Available
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount" [class.muted]="isMuted(data.limitAvlAmt)">
        {{ splitAmount(data.limitAvlAmt)[0] }}<span class="amount-cents">{{ splitAmount(data.limitAvlAmt)[1] }}</span>
      </div>
    </div>

    <!-- Debit Pending Auth -->
    <div class="card info">
      <div class="card-label">
        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M9 14l-4-4 4-4"/><path d="M5 10h11a4 4 0 0 1 0 8h-1"/></svg>
        Debit Pending Auth
      </div>
      <div class="currency-tag">{{ data.currency }}</div>
      <div class="amount" [class.muted]="isMuted(data.debitAmtPendAuth)">
        {{ splitAmount(data.debitAmtPendAuth)[0] }}<span class="amount-cents">{{ splitAmount(data.debitAmtPendAuth)[1] }}</span>
      </div>
      @if (!isMuted(data.debitAmtPendAuth)) {
        <div class="badge badge-blue">
          <span class="badge-dot"></span> Awaiting Approval
        </div>
      }
    </div>

  </div>

  <!-- FOOTER META -->
  <div class="footer-meta">
    <span>Currency: <strong>{{ data.currency }}</strong></span>
    <span>Account Officer: <strong>{{ data.acctOfficer }}</strong></span>
    <span>Customer ID: <strong>{{ data.customer }}</strong></span>
  </div>

</div>
}
